import styled from 'styled-components';

export const Container = styled.ul`
    z-index: 1;
    background: linear-gradient(180deg, #000000 0%, #0a0e27 50%, #000000 100%);
    border-right: 1px solid rgba(242, 146, 5, 0.2);
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.5);
    transition: all 0.3s ease;
    
    @media (max-width: 767px) {
        position: fixed !important;
        left: 0;
        top: 0;
        height: 100vh;
        z-index: 1000;
        width: min(18rem, calc(100vw - 12px)) !important;
        max-width: 100vw;
        transform: translateX(-100%);
        transition: transform 0.3s ease !important;
        padding-top: 4.375rem !important;
        margin-top: 0 !important;
        overflow-y: auto !important;
        overflow-x: hidden !important;
        box-sizing: border-box !important;
        
        &.toggled {
            transform: translateX(-100%);
            width: 0 !important;
            overflow: hidden;
        }
        
        &:not(.toggled) {
            transform: translateX(0);
            width: min(18rem, calc(100vw - 12px)) !important;
        }
        
        .sidebar-brand {
            padding-top: 16px !important;
            margin-top: 0 !important;
        }
        
        .nav-item {
            margin: 4px 8px !important;
            
            &:first-of-type {
                margin-top: 0 !important;
            }
        }
    }
    
    .sidebar-brand {
        padding: 24px 16px;
        transition: all 0.3s ease;
        margin-bottom: 16px !important;
        
        @media (max-width: 767px) {
            display: none !important;
        }
        
        &:hover {
            background: rgba(242, 146, 5, 0.05);
        }
        
        img {
            transition: transform 0.3s ease;
        }
        
        &:hover img {
            transform: scale(1.05);
        }
    }
    
    .sidebar-divider {
        border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
        margin: 16px 0 !important;
    }
    
    .nav-item {
        margin: 4px 8px;
        border-radius: 12px;
        transition: all 0.3s ease;
        overflow: hidden;
        
        .nav-link {
            color: #b0b0b0 !important;
            padding: 14px 16px !important;
            border-radius: 12px;
            transition: all 0.3s ease;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 12px;
            font-weight: 500;
            font-size: 15px;
            text-decoration: none !important;
            width: 100%;
            
            i {
                font-size: 20px;
                width: 24px;
                text-align: center;
                color: #888;
                transition: all 0.3s ease;
                flex-shrink: 0;
            }
            
            span {
                font-size: 14px !important;
                font-weight: 500;
                transition: all 0.3s ease;
                display: block;
                white-space: nowrap;
            }
            
            div {
                display: flex;
                align-items: center;
                gap: 12px;
                width: 100%;
            }
            
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                width: 4px;
                background: linear-gradient(180deg, #f29205 0%, #ff6b35 100%);
                transform: scaleY(0);
                transition: transform 0.3s ease;
                border-radius: 0 4px 4px 0;
            }
            
            &:hover {
                background: rgba(242, 146, 5, 0.1) !important;
                color: #ffffff !important;
                transform: translateX(4px);
                
                i {
                    color: #f29205 !important;
                    transform: scale(1.1);
                }
                
                span {
                    color: #ffffff !important;
                }
                
                &::before {
                    transform: scaleY(1);
                }
            }
        }
        
        &.active {
            background: rgba(242, 146, 5, 0.15);
            
            .nav-link {
                color: #ffffff !important;
                background: linear-gradient(90deg, rgba(242, 146, 5, 0.2) 0%, rgba(242, 146, 5, 0.05) 100%) !important;
                font-weight: 700;
                
                i {
                    color: #f29205 !important;
                    filter: drop-shadow(0 0 8px rgba(242, 146, 5, 0.6));
                }
                
                span {
                    color: #ffffff !important;
                }
                
                &::before {
                    transform: scaleY(1);
                    box-shadow: 0 0 10px rgba(242, 146, 5, 0.5);
                }
            }
        }
    }
    
    #sidebarToggle {
        width: 2.5rem;
        height: 2.5rem;
        text-align: center;
        margin-bottom: 1rem;
        cursor: pointer;
        
        &::after {
            font-weight: 900;
            content: '\f104';
            font-family: 'Font Awesome 5 Free';
            margin-right: 0.1rem;
        }
        
        &:hover {
            text-decoration: none;
        }
        
        &:focus {
            outline: none;
        }
    }
    
    &.toggled {
        width: 6.5rem !important;
        
        .sidebar-brand {
            padding: 24px 8px !important;
        }
        
        .nav-item {
            margin: 4px 8px !important;
            
            .nav-link {
                justify-content: center !important;
                align-items: center !important;
                padding: 14px 0 !important;
                width: 100% !important;
                text-align: center !important;
                
                span {
                    display: none !important;
                }
                
                i {
                    margin: 0 auto !important;
                    width: auto !important;
                }
                
                div {
                    justify-content: center !important;
                    width: 100% !important;
                }
                
                &::before {
                    display: none !important;
                }
                
                &:hover {
                    transform: none !important;
                }
            }
        }
        
        #sidebarToggle::after {
            content: '\f105';
            font-family: 'Font Awesome 5 Free';
            margin-left: 0.25rem;
        }
    }
    
    /* Estilos para quando expandido */
    &:not(.toggled) {
        .nav-item {
            .nav-link {
                justify-content: flex-start !important;
                
                span {
                    display: block !important;
                }
                
                div {
                    justify-content: flex-start;
                }
            }
        }
    }
    
    /* Submenus (collapse) — tema escuro, sem faixa branca do sb-admin */
    .collapse-inner {
        background: linear-gradient(145deg, rgba(22, 26, 48, 0.96) 0%, rgba(14, 18, 38, 0.98) 100%) !important;
        border: 1px solid rgba(242, 146, 5, 0.22) !important;
        box-shadow:
            0 10px 28px rgba(0, 0, 0, 0.45),
            inset 0 1px 0 rgba(255, 255, 255, 0.04) !important;
    }

    .collapse-inner .collapse-header {
        color: rgba(180, 190, 220, 0.75) !important;
    }

    .collapse-inner .collapse-item {
        color: rgba(230, 235, 250, 0.92) !important;
    }

    .collapse-inner .collapse-item:hover {
        background: rgba(242, 146, 5, 0.12) !important;
        color: #ffffff !important;
    }

    .collapse-inner .collapse-item:active {
        background: rgba(242, 146, 5, 0.2) !important;
    }

    .collapse-inner .collapse-item.active {
        color: #f29205 !important;
        font-weight: 700;
    }

    .collapse-inner .collapse-item i,
    .collapse-inner .collapse-item svg {
        color: #f29205 !important;
        opacity: 0.95;
    }

    .collapse-inner .collapse-item:hover i,
    .collapse-inner .collapse-item:hover svg {
        color: #ffb347 !important;
    }

    /*
     * Mobile: sb-admin-2 usa .collapse { position: absolute } (flyout à direita) só abaixo de 768px.
     * Forçar acordeão inline como em ≥768px — mesmo padrão da 2ª referência (submenu abaixo do item).
     */
    @media (max-width: 767px) {
        & .nav-item .collapse,
        & .nav-item .collapsing {
            position: relative !important;
            left: 0 !important;
            top: 0 !important;
            right: auto !important;
            z-index: 0 !important;
            width: 100% !important;
            min-width: 0 !important;
            box-sizing: border-box !important;
            animation: none !important;
        }

        & .nav-item .collapse {
            margin: 0 !important;
        }

        & .nav-item .collapsing {
            display: block !important;
            transition: height 0.2s ease !important;
        }

        .nav-item {
            overflow: visible !important;
        }

        .nav-link:hover {
            transform: none !important;
        }

        .nav-link span {
            white-space: normal !important;
            line-height: 1.35;
        }

        .nav-link div {
            align-items: flex-start !important;
            min-width: 0;
        }

        .collapse-inner {
            padding: 10px 8px !important;
            margin: 8px 0 6px !important;
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
            border-radius: 12px !important;
            box-shadow:
                inset 0 1px 0 rgba(255, 255, 255, 0.06),
                0 4px 18px rgba(0, 0, 0, 0.35) !important;
        }

        .collapse-inner .collapse-item {
            padding: 10px 8px !important;
            font-size: 13px !important;
            line-height: 1.4 !important;
            white-space: normal !important;
            word-wrap: break-word;
            overflow-wrap: anywhere;
        }

        .collapse-inner .collapse-item > div {
            display: flex !important;
            flex-wrap: wrap !important;
            align-items: flex-start !important;
            gap: 6px 8px !important;
            width: 100% !important;
            min-width: 0 !important;
            white-space: normal !important;
        }

        .collapse-inner .collapse-item i,
        .collapse-inner .collapse-item svg {
            flex-shrink: 0 !important;
            margin-top: 2px !important;
        }

        .collapse-inner .collapse-item .badge {
            margin-left: 0 !important;
            align-self: center;
        }
    }

    /* Largura expandida: desktop 14rem; mobile usa min() (não sobrescrever o bloco mobile) */
    &:not(.toggled) {
        @media (min-width: 768px) {
            width: 14rem !important;
        }

        .nav-item {
            margin: 4px 12px !important;

            @media (max-width: 767px) {
                margin: 4px 6px !important;
            }

            .nav-link {
                width: 100% !important;
                text-align: left !important;
                padding: 14px 16px !important;

                @media (max-width: 767px) {
                    padding: 12px 10px !important;
                }
            }
        }
    }
`;
